import { useCustomMediaQuery } from 'academy-common-lib/utils/Styling';
export const useResponsiveToolDisplay = ({
  collectionType
}) => {
  const hasSpaceForThree = useCustomMediaQuery('(min-width: 1500px)');
  const hasSpaceForTwo = useCustomMediaQuery('(min-width: 1400px)');
  const hasSpaceForOneShort = useCustomMediaQuery('(min-width: 1300px)');
  const hasSpaceForOneLesson = useCustomMediaQuery('(min-width: 760px)');
  if (!collectionType || hasSpaceForThree) {
    return 3;
  }
  if (hasSpaceForTwo) {
    return 2;
  }
  if (collectionType === 'shortPlaylist' && hasSpaceForOneShort || collectionType === 'lesson' && hasSpaceForOneLesson) {
    return 1;
  }
  return 0;
};